// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"702":"796ce90e227ce663b85c","715":"34dd6ecb43cd754170af","805":"9d4e0088b42948743995"}[chunkId] + ".css";
};